import { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import { messages, startmessages } from "./data/messages";

import portraitImage from "./bg_triangles_p.png";
import landscapeImage from "./bg_triangles_l.png";
import Circle from "./Components/Circle";

import LoadingScreen from "./Components/LoadingScreen.jsx";
import useScrollLock from "./Components/UseScrollLock.jsx";

gsap.registerPlugin(useGSAP, ScrollTrigger, ScrollToPlugin);
ScrollTrigger.config({ ignoreMobileResize: true });
// ScrollTrigger.normalizeScroll(true);
ScrollTrigger.saveStyles("#titles");
ScrollTrigger.saveStyles("#bgStart");
ScrollTrigger.saveStyles("#bgEnd");
// ScrollTrigger.saveStyles("#endLogo");
ScrollTrigger.saveStyles("#endPurpose");
ScrollTrigger.saveStyles("#backtopArrow");
ScrollTrigger.saveStyles("#topFakeTimeline");

let savedOrientation =
    window.innerWidth > window.innerHeight ? "landscape" : "portrait";

const App = () => {
    const [loading, setLoading] = useState(true);
    const { lockScroll, unlockScroll } = useScrollLock();
    const [overlayDarken, setOverlayDarken] = useState(false);

    useEffect(() => {
        lockScroll();
        const timer = setTimeout(() => {
            setLoading(false);
            unlockScroll();
        }, 3000); // 3 seconds

        return () => clearTimeout(timer);
    }, []);

    const isTouchDeviceTimeLine =
        "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // useEffect(() => {
    //     const handleTouch = () => setIsTouchDevice(true);
    //     window.addEventListener("touchstart", handleTouch);
    //     return () => window.removeEventListener("touchstart", handleTouch);
    // }, []);

    // const [isTouchDeviceTimeLine, setIsTouchDeviceTimeLine] = useState(false);

    // useEffect(() => {
    //     // Check if using a touch control device, show/hide joystick
    //     if ("ontouchstart" in window || navigator.maxTouchPoints > 0) {
    //         setIsTouchDeviceTimeLine(true);
    //     } else {
    //         setIsTouchDeviceTimeLine(false);
    //     }
    // }, []);

    // useEffect(() => {
    //     const handleTouch = () => setIsTouchDeviceTimeLine(true);
    //     window.addEventListener("touchstart", handleTouch);
    //     return () => window.removeEventListener("touchstart", handleTouch);
    // }, []);

    ////////////////////////////////////////////////
    const [hoveredText, setHoveredText] = useState("");

    // const handleMouseEnter = (text) => {
    const handleMouseEnter = () => {
        if (!isTouchDeviceTimeLine) {
            // setHoveredText(text);
            setOverlayDarken(true);
        }
    };

    const handleMouseLeave = () => {
        if (!isTouchDeviceTimeLine) {
            setHoveredText("");
            setOverlayDarken(false);
        }
    };

    // const handleTouchStart = (text) => {
    const handleTouchStart = () => {
        // setHoveredText(text);
        setOverlayDarken(true);
    };

    const handleTouchEnd = () => {
        setHoveredText("");
        setOverlayDarken(false);
    };
    /////////////////////////////////////////

    const [orientation, setOrientation] = useState(
        window.innerWidth > window.innerHeight ? "landscape" : "portrait"
    );

    /////////////// Background ///////////////
    const [backgroundImage, setBackgroundImage] = useState(portraitImage);

    const updateBackgroundImage = () => {
        if (window.innerWidth > window.innerHeight) {
            setBackgroundImage(landscapeImage);
        } else {
            setBackgroundImage(portraitImage);
        }
    };

    useEffect(() => {
        updateBackgroundImage();
        window.addEventListener("resize", updateBackgroundImage);
        return () =>
            window.removeEventListener("resize", updateBackgroundImage);
    }, []);
    /////////////// Background ///////////////

    const tlRef = useRef();
    const containerRef = useRef(null);
    const videoRef = useRef(null);
    const stillCanvas = useRef(null);
    let currentImage = null;
    let img = new Image();
    // const scrollFPS = 120;
    const videoFPS = 25;
    const plusStart = 0; //Add value to add to titles 'start' to affect animation frames earlier or later
    const plusEnd = 0; //Add value to add to titles 'end' to affect animation frames earlier or later
    const originalPremiereFrameCount = 3084; //Enter the Original Premiere main timeline lenght before any output speed adjustments
    const pageLength = originalPremiereFrameCount * 25;

    // Handle device and screen orientation
    useEffect(() => {
        const handleOrientation = () => {
            setOrientation(
                window.innerWidth > window.innerHeight
                    ? "landscape"
                    : "portrait"
            );

            // console.log("fired oreintation");
            window.location.reload(); // Refresh the page to ensure proper cleanup
        };

        const handleResize = () => {
            const currentOrient =
                window.innerWidth > window.innerHeight
                    ? "landscape"
                    : "portrait";

            setOrientation(
                window.innerWidth > window.innerHeight
                    ? "landscape"
                    : "portrait"
            );

            if (savedOrientation !== currentOrient) {
                setOrientation(
                    window.innerWidth > window.innerHeight
                        ? "landscape"
                        : "portrait"
                );

                savedOrientation = currentOrient;

                // console.log("fired resize");
                window.location.reload(); // Refresh the page to ensure proper cleanup
            }
        };

        screen.orientation.addEventListener("change", handleOrientation);
        window.addEventListener("resize", handleResize);

        return () => {
            // screen.orientation.addEventListener("change", handleOrientation);
            screen.orientation.removeEventListener("change", handleOrientation);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    //GSAP Goodies for Scrolling
    const { contextSafe } = useGSAP(() => {
        // ScrollTrigger.normalizeScroll(true);

        const canvas = stillCanvas.current;
        const context = canvas.getContext("2d");
        // let frameCount = 2810;
        // const durationTotal = frameCount / scrollFPS;

        function StillFrame() {
            if (ScrollTrigger.isScrolling()) {
                context.clearRect(0, 0, canvas.width, canvas.height);
            } else {
                if (
                    currentImage !==
                    Math.floor(videoRef.current.currentTime * videoFPS)
                ) {
                    if (window.innerWidth / window.innerHeight < 1) {
                        // Orientation is Portrait
                        img.src = `./scrolling/img_seq/p/tritax_building_story_p_${Math.floor(
                            videoRef.current.currentTime * videoFPS
                        )
                            .toString()
                            .padStart(4, "0")}.webp`;
                    } else {
                        // Orientation is Landscape
                        img.src = `./scrolling/img_seq/l/tritax_building_story_l_${Math.floor(
                            videoRef.current.currentTime * videoFPS
                        )
                            .toString()
                            .padStart(4, "0")}.webp`;
                    }

                    currentImage = Math.floor(
                        videoRef.current.currentTime * videoFPS
                    );
                }

                img.onload = () => {
                    context.drawImage(img, 0, 0);
                };
            }
        }

        gsap.ticker.add(StillFrame);

        // const targetsStart = gsap.utils.toArray("#bgStart");
        // const targetStartFrames = [
        //     { start: 0 + plusStart, end: 10 + plusEnd }, //id 1
        // ];

        const targets = gsap.utils.toArray("#titles");
        const targetFrames = [
            { start: 39 + plusStart, end: 72 + plusEnd }, //id 1
            { start: 106 + plusStart, end: 139 + plusEnd }, //id 2
            { start: 190 + plusStart, end: 223 + plusEnd }, //id 3
            { start: 247 + plusStart, end: 301 + plusEnd }, //id 4 - 259
            { start: 339 + plusStart, end: 372 + plusEnd }, //id 5
            { start: 399 + plusStart, end: 432 + plusEnd }, //id 6
            { start: 447 + plusStart, end: 480 + plusEnd }, //id 7
            { start: 515 + plusStart, end: 545 + plusEnd }, //id 8
            { start: 551 + plusStart, end: 584 + plusEnd }, //id 9
            { start: 591 + plusStart, end: 623 + plusEnd }, //id 10
            { start: 651 + plusStart, end: 684 + plusEnd }, //id 11
            { start: 724 + plusStart, end: 757 + plusEnd }, //id 12
            { start: 774 + plusStart, end: 832 + plusEnd }, //id 13 - 790
            { start: 905 + plusStart, end: 938 + plusEnd }, //id 14
            { start: 974 + plusStart, end: 1007 + plusEnd }, //id 15
            { start: 1050 + plusStart, end: 1083 + plusEnd }, //id 16
            { start: 1101 + plusStart, end: 1134 + plusEnd }, //id 17
            { start: 1151 + plusStart, end: 1184 + plusEnd }, //id 18
            { start: 1213 + plusStart, end: 1246 + plusEnd }, //id 19
            { start: 1266 + plusStart, end: 1321 + plusEnd }, //id 20 - 1280
            { start: 1349 + plusStart, end: 1382 + plusEnd }, //id 21
            { start: 1407 + plusStart, end: 1440 + plusEnd }, //id 22
            { start: 1464 + plusStart, end: 1497 + plusEnd }, //id 23
            { start: 1574 + plusStart, end: 1607 + plusEnd }, //id 24
            { start: 1651 + plusStart, end: 1684 + plusEnd }, //id 25
            { start: 1736 + plusStart, end: 1769 + plusEnd }, //id 26
            { start: 1830 + plusStart, end: 1863 + plusEnd }, //id 27
            { start: 1937 + plusStart, end: 1970 + plusEnd }, //id 28
            { start: 2045 + plusStart, end: 2078 + plusEnd }, //id 29
            { start: 2167 + plusStart, end: 2225 + plusEnd }, //id 31 - 2174
            { start: 2232 + plusStart, end: 2265 + plusEnd }, //id 31
            { start: 2335 + plusStart, end: 2368 + plusEnd }, //id 32
            { start: 2459 + plusStart, end: 2492 + plusEnd }, //id 33
            { start: 2578 + plusStart, end: 2611 + plusEnd }, //id 34
            { start: 2690 + plusStart, end: 2723 + plusEnd }, //id 35
            { start: 2794 + plusStart, end: 2827 + plusEnd }, //id 36
            { start: 2897 + plusStart, end: 2930 + plusEnd }, //id 37
            { start: 2964 + plusStart, end: 2997 + plusEnd }, //id 38
            // { start: 2822 + plusStart, end: 2855 + plusEnd }, //id 39
        ];

        let tl = gsap.timeline({
            scrollTrigger: {
                // trigger: '#thevideo',
                scrub: 1,
                start: "top top",
                // end: `+=${frameCount * durationTotal}`,
                // end: `+=35125`,
                end: `+=${pageLength}`,
                // pin: true,
                pin: "#container",
                // markers: true,
                invalidateOnRefresh: true,
            },
        });

        tl.to(
            "#bgStart",
            {
                autoAlpha: 0,
                // zIndex: 9999,
                duration: 25,
                ease: "none",
            },
            "0"
        );

        tl.to(
            "#backtopArrow",
            {
                autoAlpha: 1,
                // zIndex: 9999,
                duration: 15,
                ease: "none",
            },
            "0"
        );

        tl.to(
            "#topFakeTimeline",
            {
                autoAlpha: 0,
                // zIndex: 9999,
                duration: 15,
                ease: "none",
            },
            "0"
        );

        tl.to(
            "#bgEnd",
            {
                autoAlpha: 1,
                // zIndex: 9999,
                duration: 25,
                ease: "none",
            },
            "3058"
        );

        tl.to(
            "#endPurpose",
            {
                autoAlpha: 1,
                // zIndex: 9999,
                duration: 25,
                ease: "none",
            },
            "3070"
        );

        targets.forEach((target, i) => {
            const start = targetFrames[i].start; // / (frameCount - 1);
            const end = targetFrames[i].end; // / (frameCount - 1);
            // const duration = 40 / (frameCount - 1);
            // let duration = end - start;

            tl.to(
                target,
                {
                    autoAlpha: 1,
                    zIndex: 9000,
                    // duration: duration,
                    duration: 7,
                    ease: "none",
                    // y: -100,
                    // y: () => window.innerHeight * -0.17,
                    // y: () => (-window.innerHeight - target.clientHeight) / 3,
                    // yPercent: () => -window.innerHeight - 100,
                    bottom: "20%",
                },
                start
            );
            // tl.addLabel(`text-${i + 1}`, start + duration); // add a label in point of the timeline
            tl.to(
                target,
                {
                    // autoAlpha: 0,
                    // duration: end - start + duration,
                    duration: end - start,
                    // y: () => window.innerHeight * -0.35,
                    // y: () => -window.innerHeight - target.clientHeight / 10,
                    // y: -160,
                    bottom: "25%",
                },
                ">"
            );
            tl.to(
                target,
                {
                    autoAlpha: 0,
                    zIndex: -1,
                    duration: 7,
                    // y: () => window.innerHeight * -0.6,
                    // y: -300,
                    bottom: "45%",
                },
                end
            );
        });

        // targetsStart.forEach((target, i) => {
        //     const start = targetFrames[i].start; // / (frameCount - 1);
        //     const end = targetFrames[i].end; // / (frameCount - 1);
        //     // const duration = 40 / (frameCount - 1);
        //     let duration = end - start;

        //     tl.to(
        //         target,
        //         {
        //             autoAlpha: 1,
        //             zIndex: 9999,
        //             // duration: duration,
        //             duration: 7,
        //             ease: "none",
        //             // y: -100,
        //             // y: () => window.innerHeight * -0.17,
        //             // y: () => (-window.innerHeight - target.clientHeight) / 3,
        //             // yPercent: () => -window.innerHeight - 100,
        //             bottom: "20%",
        //         },
        //         start
        //     );
        // });

        // wait until video metadata is loaded, so we can grab the proper duration before adding the onscroll animation. Might need to add a loader for loonng videos
        videoRef.current.onloadedmetadata = function () {
            tl.to(
                videoRef.current,
                {
                    currentTime: videoRef.current.duration,
                    duration: originalPremiereFrameCount,
                    ease: "none",
                },
                0
            );
        };

        // This code is for my TimelinePosition thingy on the right /////////////////
        // let containerPosTimeline = document.querySelector('.containerPosTimeline');
        tl.to(
            ".currentPos",
            {
                // yPercent: -100,
                y: () =>
                    document.querySelector(".containerPosTimeline")
                        .offsetHeight,
                ease: "none",
                duration: originalPremiereFrameCount,
                onStart: function () {
                    // Offset by half its height
                    const element = document.querySelector(".currentPos");
                    const elementHeight = element.offsetHeight;
                    element.style.transform = `translateY(-${
                        elementHeight / 2
                    }px)`;
                },
            },
            0
        );
        /////////////////////////////////////////////////////////////////////////////

        // var tl2 = gsap.timeline({
        //     scrollTrigger: {
        //         scrub: 1,
        //         pin: true,
        //         // markers: true,
        //         // end: `+=${frameCount * durationTotal}-400`,
        //     },
        // });

        // tl2.from("#contentContainer", { opacity: 0, duration: 0.002 }, 0);
        // tl2.to(".start", { duration: 0.002, opacity: 0 }, "<");

        // tl2.to(".intro", { duration: 0.0015, opacity: 0 }, 0);
        // tl2.to("#contentContainer", { opacity: 0, duration: 0.0001 }, 0.1);

        // Dealing with devices
        function isTouchDevice() {
            return "ontouchstart" in window || navigator.maxTouchPoints > 0;
        }
        if (isTouchDevice()) {
            var playPromise = videoRef.current.play();

            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        videoRef.current.pause();
                    })
                    .catch(() => {});
            }
        }

        tlRef.current = tl;

        return () => {
            gsap.ticker.remove(StillFrame);
        };
    }, {});

    // My function to handle GSAP scrollTo ////////////////////////////////////////
    const handleClickJump = contextSafe((label) => {
        // console.log(label);
        const st = tlRef.current.scrollTrigger;
        // console.log(label, st.start, st.end);
        // console.log(st.start + (st.end - st.start) * (label / originalPremiereFrameCount));
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y:
                    st.start +
                    (st.end - st.start) * (label / originalPremiereFrameCount),
            },
        });
    });
    ///////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {loading && <LoadingScreen />}

            {overlayDarken && (
                <div className="fixed w-full h-screen bg-[#003c4d] z-[8999] opacity-75"></div>
            )}

            <div
                ref={containerRef}
                id="contentContainer"
                // className="opacity-10"
            >
                <canvas
                    className="fixed -translate-x-2/4 -translate-y-2/4 w-full h-screen object-cover z-[2] left-2/4 top-2/4"
                    ref={stillCanvas}
                    id="image-sequence"
                    width={orientation == "landscape" ? "1920" : "1080"}
                    height={orientation == "landscape" ? "1080" : "1920"}
                />
                <video
                    ref={videoRef}
                    className="fixed w-full h-screen object-cover"
                    id="thevideo"
                    playsInline={true}
                    // webkit-playsinline="true"
                    preload="auto"
                    muted
                >
                    <source
                        src={
                            orientation == "landscape"
                                ? "./scrolling/video/tritax_building_story_l.mp4"
                                : "./scrolling/video/tritax_building_story_p.mp4"
                        }
                        type="video/mp4"
                    />
                </video>

                <div className="absolute z-[8500] flex flex-col items-center justify-center h-screen w-full left-0 top-0">
                    {startmessages.map(
                        ({ id, heading1, heading2, main, instructions }) => (
                            <div
                                key={id}
                                className="w-3/5 md:w-1/2 lg:w-1/2 xl:w-2/3 2xl:w-3/5"
                            >
                                {/* text-[#3f3a34] */}
                                <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl leading-tight text-center text-[#f2f1f0] tracking-widest">
                                    {heading1}
                                    {/* <span className="text-[#ff6400]">.</span> */}
                                </h1>
                                <h1 className="text-base md:text-xl lg:text-2xl xl:text-4xl 2xl:text-5xl leading-tight text-center text-[#ff6400] tracking-widest">
                                    {heading2}
                                </h1>
                                <br />
                                <br />
                                {/* text-[#e5e3e1] */}
                                <div>
                                    <p className="text-base md:text-base lg:text-xl xl:text-3xl 2xl:text-4xl leading-tight text-[#f2f1f0]">
                                        {main}
                                    </p>
                                    <br />
                                    <br />
                                    <p className="text-base md:text-base lg:text-xl xl:text-3xl 2xl:text-4xl leading-tight text-[#f2f1f0]">
                                        {instructions}
                                    </p>
                                    <br />
                                    <img
                                        src="./images/scroll_down.png"
                                        width={61}
                                        height={112}
                                        className="pt-10 mx-auto my-0 scale-50 md:scale-50 lg:scale-75 xl:scale-100 2xl:scale-100"
                                    />
                                </div>
                            </div>
                        )
                    )}
                </div>

                <div id="container" className="relative z-[2] w-full h-screen">
                    <div
                        id="bgStart"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${backgroundImage})`,
                            // backgroundSize: "contain", // Fit horizontally
                            backgroundSize: "100%", // Fit horizontally
                            backgroundRepeat: "no-repeat", // Prevent repeating
                            backgroundPosition: "bottom", // Center the image
                            backgroundColor: "#003C4D",
                            // opacity: "100",
                        }}
                    >
                        {/* Your content goes here */}
                    </div>

                    {messages.map(
                        ({
                            id,
                            alignment,
                            heading1,
                            heading2,
                            heading3,
                            main,
                        }) => {
                            let alignmentClass = "";
                            let headingClass1 = "";
                            let headingClass2 = "";
                            let headingClass3 = "";
                            let mainClass = "";

                            switch (alignment) {
                                case "left":
                                    alignmentClass =
                                        "absolute w-1/2 md:w-2/5 lg:w-2/5 xl:w-1/3 2xl:w-2/5 opacity-0 left-[15%] md:left-[10%] xl:left-[9%] 2xl:left-[8%] bottom-[0%] text-left";
                                    headingClass1 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest text-[#ff6400]";
                                    headingClass2 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest";
                                    mainClass =
                                        "text-base md:text-base lg:text-xl xl:text-3xl 2xl:text-4xl";
                                    break;
                                case "right":
                                    alignmentClass =
                                        "absolute w-1/2 md:w-2/5 lg:w-2/5 xl:w-1/3 2xl:w-2/5 opacity-0 right-[7%] bottom-[0%] text-right";
                                    headingClass1 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest text-[#ff6400] text-right";
                                    headingClass2 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest text-right";
                                    mainClass =
                                        "text-base md:text-base lg:text-xl xl:text-3xl 2xl:text-4xl";
                                    break;
                                case "centerW":
                                    alignmentClass =
                                        "left-1/2 transform -translate-x-1/2 w-3/4 md:w-3/4 lg:w-3/4 xl:w-2/3 2xl:w-3/4 absolute opacity-0 bottom-[0%]";
                                    headingClass1 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest font-['Gotham-Medium'] font-black";
                                    headingClass2 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest";
                                    headingClass3 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest text-[#ff6400]";
                                    mainClass =
                                        "text-base md:text-base lg:text-xl xl:text-3xl 2xl:text-4xl";
                                    break;
                                case "centerO":
                                    alignmentClass =
                                        "left-1/2 transform -translate-x-1/2 w-3/5 md:w-1/2 lg:w-1/2 xl:w-2/3 2xl:w-3/5 absolute opacity-0 bottom-[0%]";
                                    headingClass1 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest text-[#ff6400]";
                                    headingClass2 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest";
                                    headingClass3 =
                                        "text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-7xl uppercase tracking-widest text-[#ff6400]";
                                    mainClass =
                                        "text-base md:text-base lg:text-xl xl:text-3xl 2xl:text-4xl";
                                    break;
                                // default:
                                //     alignmentClass = "text-left"; // Default alignment
                            }

                            return (
                                <div
                                    key={id}
                                    id="titles"
                                    className={alignmentClass}
                                >
                                    <h1>
                                        <span className={headingClass1}>
                                            {heading1}
                                        </span>
                                        <br />
                                        <span className={headingClass2}>
                                            {heading2}
                                        </span>
                                        <span className={headingClass3}>
                                            {heading3}
                                        </span>
                                    </h1>
                                    <br />
                                    <br />
                                    <p className={mainClass}>{main}</p>
                                </div>
                            );
                        }
                    )}

                    <div
                        id="bgEnd"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            // backgroundImage: `url(${backgroundImage})`,
                            // backgroundSize: "contain", // Fit horizontally
                            backgroundSize: "100%", // Fit horizontally
                            backgroundRepeat: "no-repeat", // Prevent repeating
                            backgroundPosition: "bottom", // Center the image
                            // backgroundColor: "#003C4D",
                            backgroundColor: "#00000077",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            opacity: "0",
                        }}
                    >
                        <img
                            id="endLogo"
                            src="./tbb_logo_white.png"
                            alt=""
                            width={490}
                            height={138}
                            // style={{ width: "490px", height: "138px" }}
                            className="scale-50 md:scale-50 lg:scale-75 xl:scale-100 2xl:scale-100"
                        />
                        <br />
                        <br />
                        <div
                            id="endPurpose"
                            className="text-base md:text-base lg:text-xl xl:text-3xl 2xl:text-4xl text-center opacity-0"
                        >
                            Creating Critical Infrastructure to
                            <br />
                            Accommodate the Future
                        </div>
                    </div>

                    <div
                        className="opacity-0 flex items-baseline fixed z-[9000] right-[2%] bottom-[3%] text-right text-sm align-bottom"
                        id="backtopArrow"
                    >
                        <a
                            className="opacity-30 pr-6"
                            href="https://blinkimage.com/"
                            target="_blank"
                            // rel="noopener noreferrer"
                        >
                            Experience by Blink Image
                        </a>
                        <img
                            src="./images/icon-arrow-top-circle-orange.svg"
                            width={56}
                            height={56}
                            className="cursor-pointer ms-auto my-0 scale-50 md:scale-50 lg:scale-75 xl:scale-100 2xl:scale-100"
                            onClick={() => handleClickJump(0)}
                        />
                    </div>
                </div>
            </div>

            <div className="z-[9000] fixed h-[75vh] flex flex-col m-0 p-0 left-[2%] top-1/2 transform -translate-y-1/2">
                <div className="flex-none text-xs opacity-30">
                    Skip to
                    <br />
                    Chapter
                </div>
                {/* ////////////////////////////////////////////////////// */}
                <div
                    className="containerPosTimeline"
                    id="topActualTimeline"
                    // className="fixed h-[300px] w-[200px] -translate-y-2/4 overflow-hidden z-[9999] m-0 p-0 border-[solid] border-[green] right-[50px] top-2/4;"
                >
                    <div
                        className="currentPos"
                        // className="fixed h-0.5 w-[170px] z-[5] m-0 p-0 border-[solid] border-[red] right-5 top-2/4;"
                    >
                        <Circle
                            radius={12}
                            fill="#ff6400"
                            stroke="none"
                            strokeWidth={1}
                        />
                    </div>

                    <div
                        // className="inner"
                        className="h-full"
                    >
                        <div className="lineTimeline"></div>

                        {/* /////////////// */}
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "0%" }}
                            onClick={() => handleClickJump(0)}
                            onMouseEnter={() => handleMouseEnter("START")}
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() => handleTouchStart("START")}
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            {/* {hoveredText === "START" && <span>START</span>} */}
                            {overlayDarken && <span>START</span>}
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "8.398184176394293%" }}
                            // style={{ top: "8.6%" }}
                            onClick={() => handleClickJump(259)}
                            onMouseEnter={() =>
                                handleMouseEnter("CONSTRUCTION")
                            }
                            onMouseLeave={() => handleMouseLeave()}
                            // onTouchStart={() =>
                            //     handleTouchStart("CONSTRUCTION")
                            // }
                            // onTouchEnd={() => handleTouchEnd()}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            {/* {hoveredText === "CONSTRUCTION" && (
                                <span>CONSTRUCTION</span>
                            )} */}
                            {overlayDarken && <span>CONSTRUCTION</span>}
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "25.61608300907912%" }}
                            // style={{ top: "26%" }}
                            onClick={() => handleClickJump(790)}
                            onMouseEnter={() =>
                                handleMouseEnter("ENERGY SERVICES")
                            }
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() =>
                            //     handleTouchStart("ENERGY SERVICES")
                            // }
                            // onTouchEnd={handleTouchEnd}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                                style={{ padding: "10px" }}
                            />
                            {/* {hoveredText === "ENERGY SERVICES" && (
                                <span>ENERGY SERVICES</span>
                            )} */}
                            {overlayDarken && <span>ENERGY SERVICES</span>}
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "41.50453955901427%" }}
                            // style={{ top: "42.2%" }}
                            onClick={() => handleClickJump(1280)}
                            onMouseEnter={() =>
                                handleMouseEnter("OUR SPECIFICATION")
                            }
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() =>
                            //     handleTouchStart("OUR SPECIFICATION")
                            // }
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            {/* {hoveredText === "OUR SPECIFICATION" && (
                                <span>OUR SPECIFICATION</span>
                            )} */}
                            {overlayDarken && <span>OUR SPECIFICATION</span>}
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "70.49286640726329%" }}
                            // style={{ top: "71.6%" }}
                            onClick={() => handleClickJump(2174)}
                            onMouseEnter={() =>
                                handleMouseEnter("EXTERNAL & WELLBEING")
                            }
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() =>
                            //     handleTouchStart("EXTERNAL & WELLBEING")
                            // }
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            {/* {hoveredText === "EXTERNAL & WELLBEING" && (
                                <span>EXTERNAL & WELLBEING</span>
                            )} */}
                            {overlayDarken && <span>EXTERNAL & WELLBEING</span>}
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "100%" }}
                            onClick={() => handleClickJump(3084)}
                            onMouseEnter={() => handleMouseEnter("END")}
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() => handleTouchStart("END")}
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            {/* {hoveredText === "END" && <span>END</span>} */}
                            {overlayDarken && <span>END</span>}
                        </p>
                    </div>
                </div>

                <div
                    className="containerPosTimeline hidden 2xl:block opacity-50"
                    id="topFakeTimeline"
                    // className="fixed h-[300px] w-[200px] -translate-y-2/4 overflow-hidden z-[9999] m-0 p-0 border-[solid] border-[green] right-[50px] top-2/4;"
                >
                    <div
                        className="currentPos"
                        // className="fixed h-0.5 w-[170px] z-[5] m-0 p-0 border-[solid] border-[red] right-5 top-2/4;"
                    >
                        <Circle
                            radius={12}
                            fill="#ff6400"
                            stroke="none"
                            strokeWidth={1}
                        />
                    </div>

                    <div
                        // className="inner"
                        className="h-full"
                    >
                        <div className="lineTimeline"></div>

                        {/* /////////////// */}
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "0%" }}
                            onClick={() => handleClickJump(0)}
                            onMouseEnter={() => handleMouseEnter("START")}
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() => handleTouchStart("START")}
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            <span>START</span>
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "8.398184176394293%" }}
                            // style={{ top: "8.6%" }}
                            onClick={() => handleClickJump(259)}
                            onMouseEnter={() =>
                                handleMouseEnter("CONSTRUCTION")
                            }
                            onMouseLeave={() => handleMouseLeave()}
                            // onTouchStart={() =>
                            //     handleTouchStart("CONSTRUCTION")
                            // }
                            // onTouchEnd={() => handleTouchEnd()}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            <span>CONSTRUCTION</span>
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "25.61608300907912%" }}
                            // style={{ top: "26%" }}
                            onClick={() => handleClickJump(790)}
                            onMouseEnter={() =>
                                handleMouseEnter("ENERGY SERVICES")
                            }
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() =>
                            //     handleTouchStart("ENERGY SERVICES")
                            // }
                            // onTouchEnd={handleTouchEnd}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                                style={{ padding: "10px" }}
                            />
                            <span>ENERGY SERVICES</span>
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "41.50453955901427%" }}
                            // style={{ top: "42.2%" }}
                            onClick={() => handleClickJump(1280)}
                            onMouseEnter={() =>
                                handleMouseEnter("OUR SPECIFICATION")
                            }
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() =>
                            //     handleTouchStart("OUR SPECIFICATION")
                            // }
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            <span>OUR SPECIFICATION</span>
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "70.49286640726329%" }}
                            // style={{ top: "71.6%" }}
                            onClick={() => handleClickJump(2174)}
                            onMouseEnter={() =>
                                handleMouseEnter("EXTERNAL & WELLBEING")
                            }
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() =>
                            //     handleTouchStart("EXTERNAL & WELLBEING")
                            // }
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            <span>EXTERNAL & WELLBEING</span>
                        </p>
                        <p
                            // className="flex absolute cursor-pointer m-0 p-0 right-0;"
                            style={{ top: "100%" }}
                            onClick={() => handleClickJump(3084)}
                            onMouseEnter={() => handleMouseEnter("END")}
                            onMouseLeave={handleMouseLeave}
                            // onTouchStart={() => handleTouchStart("END")}
                            // onTouchEnd={handleTouchEnd}
                            // onTouchMove={handleTouchMove}
                        >
                            <Circle
                                radius={12}
                                fill="#003C4D"
                                stroke="#ff6400"
                                strokeWidth={1.5}
                            />
                            <span>END</span>
                        </p>
                    </div>
                </div>
            </div>

            {/* <div className="fixed flex z-[9000] right-[4%] bottom-[3%] text-right opacity-30 text-sm">
                <a
                    href="https://blinkimage.com/"
                    target="_blank"
                    // rel="noopener noreferrer"
                >
                    Experience by Blink Image
                </a>
            </div> */}
            {/* <div className="flex items-baseline fixed z-[9000] right-[2%] bottom-[3%] text-right text-sm align-bottom">
                <a
                    className="opacity-30 pr-6"
                    href="https://blinkimage.com/"
                    target="_blank"
                    // rel="noopener noreferrer"
                >
                    Experience by Blink Image
                </a>
                <img
                    id="backtopArrow"
                    src="./images/icon-arrow-top-circle-orange.svg"
                    width={56}
                    height={56}
                    className="cursor-pointer ms-auto my-0 scale-50 md:scale-50 lg:scale-75 xl:scale-100 2xl:scale-100 opacity-0"
                    onClick={() => handleClickJump(0)}
                />
            </div> */}
        </>
    );
};

export default App;
